import { gql } from '@provision/graphql-client';
import { CONVERSATION_SUMMARY_FIELDS } from './conversation-summary.fragments';

export const GET_CONVERSATION_SUMMARY_QUERY = gql`
  query GenerateConversationSummary($params: GenerateConversationSummaryParams!) {
    generateConversationSummary(params: $params) {
      ...ConversationSummaryFields
    }
  }
  ${CONVERSATION_SUMMARY_FIELDS}
`;
